// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe[data-v-44b9821f]{height:100%}*[data-v-44b9821f]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
